import {reactive, Ref} from "@vue/composition-api";
import type Vue from "vue";

export interface NavbarBoxModel {
    pageContext: PageContext | null | undefined;
}

export interface PageAction {
    name: string;
    action: Function | Promise<unknown>;
    enabled?: boolean | null;
}

export interface BreadcrumbSegment {
    text: string;
    icon?: string;
    route?: string | null;
}

export interface PageBreadcrumb {
    showHome?: false;
    segments: Array<BreadcrumbSegment>;
}

export interface Title {
    text: string;
    icon?: string;
    action?: Function;
    iconII?: string;
    actionII?: Function;
}

export interface PageContext {
    title: Title;
    actions: Array<PageAction | '-'>;
    controls?: Ref<null>;
    breadcrumb: PageBreadcrumb;
}

export function createPageContext(context: PageContext): PageContext {
    return reactive(context) as unknown as PageContext;
}

export interface Page extends Vue {
    pageContext: PageContext;
}
